import { initRiveCanvas } from "./rive";
import { initLottieAnimation } from "./lottie";

export function initMoreRows() {
    const moreRows = document.querySelectorAll('[data-more-rows]');
    for (const row of moreRows) {
        row.addEventListener('shown.bs.collapse', (e) => {
            const canvases = e.target.querySelectorAll('.rive-animation-canvas.quote');
            for (const canvas of canvases) {
                initRiveCanvas(canvas);
            }
            const lottieContainers = e.target.querySelectorAll('.lottie-animation.quote');
            for (const container of lottieContainers) {
                initLottieAnimation(container);
            }
        })

        row.addEventListener('show.bs.collapse', (e) => {
            const activator = document.querySelector("#moreRows");
            const currentIndex = parseInt(activator.dataset.moreRowsIndex);
            const nextSelector = `[data-more-rows='${currentIndex + 1}']`
            if (document.querySelector(nextSelector)) {
                activator.setAttribute("data-bs-target", nextSelector);
                activator.setAttribute("data-more-rows-index", currentIndex + 1);
            } else {
                activator.classList.add("d-none");
                activator.previousElementSibling.classList.add("d-none");
                document.querySelector("#ownButton").classList.remove("d-none");
            }
        })
    }
}